<template>
  <v-card
    class="px-4 py-3 d-flex align-center"
    elevation="0"
    outlined
    height="160"
  >
    <v-skeleton-loader v-if="showImage" type="image" width="104" height="107" />
    <div class="d-flex flex-column flex-grow-1 justify-start align-start ms-3">
      <div class="d-flex align-center mb-1">
        <v-skeleton-loader class="me-1" type="text" width="14" />
        <div>
          <v-skeleton-loader class="mb-1" type="text" width="100" />
          <v-skeleton-loader class="mb-1" type="text" width="150" />
        </div>
      </div>

      <v-skeleton-loader class="mb-1" type="text" width="150" />
      <v-skeleton-loader class="mb-1" type="text" width="50" />
      <div
        class="d-flex justify-space-between align-center"
        style="width: 100%"
      >
        <div class="flex-grow-0 d-flex flex-column" style="height:20px">
          <v-skeleton-loader class="mb-1" type="text" width="70" />
        </div>
        <v-skeleton-loader class="mb-1" type="text" width="14" />
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ToDoCardSkeleton',
  props: {
    showImage: Boolean,
  },
}
</script>
